import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG Imports
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AvatarModule } from 'primeng/avatar';
import { TabsModule } from 'primeng/tabs';
import { DividerModule } from 'primeng/divider';
import { TagModule } from 'primeng/tag';
import { ChipModule } from 'primeng/chip';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { ConfigService } from 'src/app/_services/config.service';
import { PortalService } from '../_services/portal.service';
import { Router } from '@angular/router';
import { User } from 'src/app/_models/User.model';
import { TranslateModule } from '@ngx-translate/core';
import { Role } from 'src/app/_models/portal/Role.model';
import { Portal } from 'src/app/_models/portal/Portal.model';

@Component({
	selector: 'app-user-profile',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		CardModule,
		ButtonModule,
		InputTextModule,
		AvatarModule,
		TabsModule,
		DividerModule,
		TagModule,
		ChipModule,
		ToggleButtonModule,
		DatePickerModule,
		SelectModule,
		ProgressBarModule,
		BadgeModule,
		TableModule,
		PanelModule,
		TooltipModule,
		TranslateModule,
	],
	templateUrl: './profilo.component.html',
	styleUrls: ['./profilo.component.css'],
})
export class ProfiloComponent implements OnInit {
	constructor(private router: Router, public configService: ConfigService, private portalservice: PortalService) {}

	user!: User;

	isEditMode = false;
	editableUser: User = { ...this.user };

	assignedPortals!: Portal[];
	assignedRoles!: Role[];

	ngOnInit() {
		this.getUser();
		this.getUserRoles();
		this.getUserPortals();
	}

	getUser() {
		this.portalservice.getUser(this.configService.getUserID()).subscribe({
			next: (user) => {
				this.user = user;
				this.editableUser = { ...this.user };
			},
		});
	}

	getUserRoles() {
		this.portalservice.getRuoliUser(this.configService.getUserID()).subscribe({
			next: (roles) => {
				this.assignedRoles = roles?.filter((role: Role) => role.rl_isChecked);
			},
		});
	}

	getUserPortals() {
		this.portalservice.getPortali('', 'pt_descrizione', '', 1, 9999).subscribe({
			next: (portale: Portal[]) => {
				this.assignedPortals = portale;
			},
		});
	}

	toggleEditMode() {
		if (this.isEditMode) {
			// Save changes
			this.user = { ...this.editableUser };
		} else {
			// Enter edit mode
			this.editableUser = { ...this.user };
		}
		this.isEditMode = !this.isEditMode;
	}

	cancelEdit() {
		this.editableUser = { ...this.user };
		this.isEditMode = false;
	}

	getRoleSeverity(roleType: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined {
		switch (roleType.toLowerCase()) {
			case 'admin':
				return 'danger';
			case 'developer':
				return 'info';
			case 'manager':
				return 'warn';
			case 'user':
				return 'success';
			default:
				return 'secondary';
		}
	}

	getPortalStatusSeverity(isActive: boolean): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined {
		return isActive ? 'success' : 'secondary';
	}

	getActivePortalsCount(): number {
		return this.assignedPortals.length;
	}

	getActiveRolesCount(): number {
		return this.assignedRoles?.filter((role) => role.rl_isChecked).length || 0;
	}
}
